const state = {
  request : null
};

const getters = {
  requestSort : state => state.request
};

const mutations = {
  SET_SORT : (state, { model, sort }) => {

    state[model] = sort;
  }
};

const actions = {
  updateSort({ commit }, { model, sort }) {

    commit('SET_SORT', { model, sort });
  }
};

export default {
  state,
  getters,
  actions,
  mutations
};
